// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"a532720c","453":"5e51224a","732":"321557d4"}[chunkId] + ".chunk.js";
};